/** Client-side defaults mirroring lib/platformEndpoints.js */

export function defaultEndpointConfigForPlatform(platformAdapterName) {
  if (platformAdapterName === 'bridgeInteractive') {
    return {
      odataBaseUrl: 'https://api.bridgedataoutput.com/api/v2/OData/YOUR_DATASET',
      resourceFilters: {},
    }
  }
  if (platformAdapterName === 'trestle') {
    return {
      odataBaseUrl: 'https://api-trestle.corelogic.com/trestle/odata',
      resourceFilters: {},
    }
  }
  if (platformAdapterName === 'mlsGrid') {
    return {
      odataBaseUrl: 'https://api.mlsgrid.com/v2',
      originatingSystemName: 'YOUR_MLS',
      requireCanView: true,
      resourceFilters: {},
    }
  }
  if (platformAdapterName === 'rmls') {
    return {
      odataBaseUrl: 'https://YOUR_RMLS_HOST/odata',
      resourceFilters: {},
    }
  }
  return {
    odataBaseUrl: '',
    resourceFilters: {},
  }
}
